import { useFormContext } from "react-hook-form";
import { FieldConfig } from "../../formConfig";

export default function TextField({ field, type = "text" }: { field: FieldConfig; type?: string }) {
  const { register } = useFormContext();
  return <input id={field.id} type={type} autoComplete="nope" data-form-type="other" data-lpignore="true" data-1p-ignore {...register(field.id)} />;
}
